import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false }) => (
  <div className="flex items-center gap-3 mb-6">
    <span className={`h-px w-10 ${dark ? "bg-saffron" : "bg-maroon"}`} />
    <span
      className={`text-sm uppercase tracking-[0.28em] ${
        dark ? "text-saffron" : "text-maroon"
      }`}
    >
      {children}
    </span>
  </div>
);
